import React from 'react';
import { PropTypes } from 'prop-types';
import AddIconCircle from 'components/atoms/icons/addIconCircle';

const ModalTitle = ({ addHandler }) => (
  <div className="care-locations__title">
    <div className="care-locations__title-txt">Care locations</div>
    <button className="care-locations__add-btn" onClick={addHandler}>
      <AddIconCircle />
    </button>
  </div>
);

ModalTitle.propTypes = {
  addHandler: PropTypes.func.isRequired,
};

export default ModalTitle;
